import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../assets/css/About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import data from "../../src/component/ApiUrl/meta_api";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLightbulb,
  faStar,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";

function AboutUs() {
  const [meta, setMeta] = useState(null);

  const fetchData = () => {
    const AboutMeta = data[0]?.about_page;
    if (AboutMeta) {
      setMeta(AboutMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "About"}</title>
      </Helmet>
      {/* <!-- Page Header Start --> */}
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <h1 className="display-3 text-white animated slideInRight">
            About Us
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animated slideInRight mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                About Us
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* <!-- Page Header Start --> */}

      {/* Who we are start */}
      <div className="container ">
        <div className="row ">
          <div className="col-lg-5 col-md-6 col-sm-12" data-aos="fade-down">
            <img
              className="who_we_are_aboutImg object-fit-cover"
              src={require("../assets/img/About_Us/images.jpg")}
            ></img>
          </div>
          <div className="col-lg-7 col-md-6 col-sm-12" data-aos="fade-left">
            {/* <div className="card who_we_are_about p-4 "> */}
            <h4 className="">About us</h4>

            <div className="section-header ">
              <h1 className="section-title text-danger">
                Skimitar <span className="text-dark">Hindusthan</span>
              </h1>
            </div>
            {/* <p className="pasagejustify fs-6">
              Skimitar Hindusthan, we specialize in providing innovative and
              reliable industrial automation solutions that enhance efficiency,
              productivity, and safety across various sectors. Our team of
              experts delivers customized automation systems, leveraging the
              latest technologies such as robotics, IoT, PLCs, and AI.
            </p>

            <p className="pasagejustify fs-6">
              From system design and installation to ongoing support and
              maintenance, we offer comprehensive services tailored to meet your
              unique needs. With 7 years of experience and a proven track
              record, we help businesses stay competitive in today's
              fast-evolving industrial landscape.
            </p>
            <p className="pasagejustify fs-6">
              Welcome to Skimitar Hindusthan, where industrial innovation meets
              operational excellence. We specialize in designing and
              implementing industrial automation solutions tailored to meet the
              needs of industries worldwide.
            </p> */}
            <p className="pasagejustify justified-text fs-6">
              Skimitar Automation, we specialize in providing innovative and
              reliable industrial automation solutions that enhance efficiency,
              productivity, and safety across various sectors. Our team of
              experts delivers customized automation systems, leveraging the
              latest technologies such as robotics, IOT, PLCs, and AI. We focus
              on optimizing production processes, reducing operational costs,
              and ensuring seamless integration with existing systems. From
              system design and installation to ongoing support and maintenance,
              we offer comprehensive services tailored to meet your unique
              needs. With 7 years of experience and a proven track record, we
              help businesses stay competitive in today’s fast-evolving
              industrial landscape. Our solutions drive mesurable improvements
              and sustainable growth. Partner with Skimitar Automation to
              elevate your industrial operations to new heights.
            </p>

            {/* </div> */}
          </div>
        </div>
      </div>
      {/* who we are end */}

      <div className="row">
        <div className="col-lg-10">
          <div className=" my-4 my-md-5 px-5 px-md-4">
            <div className="card shadow-sm border-0 rounded-3 overflow-hidden cardaboutvison">
              <div className="row g-0">
                <div className="col-12 col-lg-7 order-2 order-lg-1 p-3 p-md-4 p-lg-5 d-flex align-items-center bg-light">
                  <div>
                    {/* <h2 className="text-danger mb-3 mb-md-4">Our Vision</h2> */}
                    <div className="section-header mb-4">
                      <h2 className="section-title text-danger">
                        Our <span className="text-dark"> Vision</span>
                      </h2>
                    </div>
                    <div className="vision-content">
                      {/* <p className="text-dark mb-3 centercardpara fs-6">
                        Skimitar Hindusthan, our vision is to be a leader in
                        manufacturing industrial projects by delivering
                        innovative solutions that enhance productivity and
                        operational efficiency.
                      </p>
                      <p className="text-dark mb-0 centercardpara fs-6">
                        We aim to empower manufacturers with advanced automation
                        technologies that optimize production processes and
                        reduce costs. Our focus is on providing scalable,
                        customized solutions that drive sustainable growth and
                        improve quality standards.
                      </p> */}

                      <p className="fs-6 justified-text">
                        Skimitar Hindusthan, our vision is to be a leader in
                        manufacturing industrial projects by delivering
                        innovative solutions that enhance productivity and
                        operational efficiency. We aim to empower manufacturers
                        with advanced automation technologies that optimize
                        production processes and reduce costs. Our focus is on
                        providing scalable, customized solutions that drive
                        sustainable growth and improve quality standards. We are
                        committed to fostering long-term partnerships with our
                        clients by ensuring continuous improvement and
                        exceptional support. Through innovation and expertise,
                        we strive to shape the future of manufacturing
                        industries worldwide.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-5 order-1 order-lg-2">
                  <img
                    className="img-fluid h-100 w-100 object-fit-cover"
                    src={require("../../src/assets/img/About_Us/Our Vision Skimitar Hindusthan.png")}
                    alt="Our Vision"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2"></div>
      </div>

      <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-10">
          <div className=" my-4 my-md-5 px-5 px-md-4">
            <div className="card shadow-sm border-0 rounded-3 overflow-hidden cardaboutmission">
              <div className="row g-0">
                <div className="col-lg-5 ">
                  <img
                    className="img-fluid h-100 w-100 object-fit-cover "
                    src={require("../../src/assets/img/About_Us/Our Mission Skimitar Hindusthan,.png")}
                    alt="Our Vision"
                    loading="lazy"
                  />
                </div>
                <div className="col-6  col-lg-7 order-2 order-lg-1 p-3 p-md-4 p-lg-5 d-flex align-items-center bg-light">
                  <div>
                    <div className="section-header mb-4">
                      <h2 className="section-title text-danger">
                        Our <span className="text-dark"> Mission</span>
                      </h2>
                    </div>
                    <div className="mission-content">
                      {/* <p className="text-dark mb-3 centercardpara fs-6">
                        Skimitar Hindusthan, our mission is to provide
                        innovative and efficient automation solutions that
                        enhance the performance of manufacturing industries.
                      </p>
                      <p className="text-dark mb-0 centercardpara fs-6">
                        We are committed to delivering customized, high-quality
                        industrial projects that optimize production processes
                        and drive cost-effectiveness. By integrating the latest
                        technologies, we aim to help businesses achieve
                        sustainable growth and operational excellence.
                      </p> */}

                      <p className="fs-6 justified-text">
                        Skimitar Hindusthan, our mission is to provide
                        innovative and efficient automation solutions that
                        enhance the performance of manufacturing industries. We
                        are committed to delivering customized, high-quality
                        industrial projects that optimize production processes
                        and drive cost-effectiveness. By integrating the latest
                        technologies, we aim to help businesses achieve
                        sustainable growth and operational excellence. Our focus
                        is on delivering scalable, reliable solutions that meet
                        the unique needs of each client. Through continuous
                        support and expertise, we strive to lead the
                        transformation of the manufacturing sector.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Core Values Section */}
      <div className="container py-4 py-md-5 px-3 px-md-4">
        <div className="text-center mb-4 mb-md-5">
          <h2 className="text-danger fw-bold mb-3">Our Core Values</h2>
        </div>

        <div className="row g-3 g-md-4">
          {/* Innovative Solutions Card */}
          <div className="col-12 col-md-6 col-lg-4 mb-3 mb-lg-0">
            <div className="card h-100 p-3 p-md-4 bg-white border-0 rounded-3 centerparashadow about_bottom_card">
              <div
                className="rounded-circle bg-light d-flex justify-content-center align-items-center mx-auto mb-3"
                style={{ width: "80px", height: "80px" }}
              >
                <FontAwesomeIcon
                  icon={faLightbulb}
                  className="fa-2x text-danger"
                />
              </div>
              <h4 className="text-center mb-3">Innovative Solutions</h4>
              <p className=" text-center mb-0 centercardpara fs-6">
                We use the latest technologies to design solutions that drive
                efficiency and reduce costs.
              </p>
            </div>
          </div>

          {/* Reliable Services Card */}
          <div className="col-12 col-md-6 col-lg-4 mb-3 mb-lg-0">
            <div className="card h-100  p-3 p-md-4 bg-white border-0 rounded-3 centerparashadow about_bottom_card">
              <div
                className="rounded-circle bg-light d-flex justify-content-center align-items-center mx-auto mb-3"
                style={{ width: "80px", height: "80px" }}
              >
                <FontAwesomeIcon icon={faStar} className="fa-2x text-danger" />
              </div>
              <h4 className="text-center mb-3">Reliable Services</h4>
              <p className=" text-center mb-0 centercardpara fs-6">
                We provide end-to-end support, ensuring your operations run
                without interruption.
              </p>
            </div>
          </div>

          {/* Proven Track Record Card */}
          <div className="col-12 col-md-6 col-lg-4 mx-auto">
            <div className="card h-100  p-3 p-md-4 bg-white border-0 rounded-3 centerparashadow about_bottom_card">
              <div
                className="rounded-circle bg-light d-flex justify-content-center align-items-center mx-auto mb-3"
                style={{ width: "80px", height: "80px" }}
              >
                <FontAwesomeIcon
                  icon={faHandshake}
                  className="fa-2x text-danger"
                />
              </div>
              <h4 className="text-center mb-3">Proven Track Record</h4>
              <p className=" text-center mb-0 centercardpara fs-6">
                We've partnered with top-tier clients, delivering exceptional
                results and growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
